import { useQuery } from '@tanstack/react-query';
import { ShiftResource, shiftsGetShiftsWithoutTeamLeader } from '~/generated';
import { extractData } from '~/utils/query-utils';

type ShiftResourceWithId = {
  id: number;
} & Omit<ShiftResource, 'id'>;

export const useShiftsWithoutTeamLead = () =>
  useQuery({
    queryFn: () =>
      extractData(shiftsGetShiftsWithoutTeamLeader()) as unknown as Promise<
        ShiftResourceWithId[]
      >,
    queryKey: ['Shifts', 'withoutTeamLeader'],
  });
